import SecondaryWalletType from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletType";

export default class SecondaryWalletSettings {
    secondaryWalletTypes: SecondaryWalletType[] = [];
}